import ReactQuill from 'react-quill';
import React, {Component} from 'react';
import 'react-quill/dist/quill.snow.css';

function insertText(value) {
	const cursorPosition = this.quill.getSelection().index;
	this.quill.insertText(cursorPosition, value);
	this.quill.setSelection(cursorPosition + value.length);
}

const CustomToolbar = ({shortId, templates}) => (
	<div id={'t'+shortId}>
		<select
			className="ql-header"
			defaultValue={''}
			onChange={(e) => e.persist()}
		>
			<option value="1"></option>
			<option value="2"></option>
		</select>
		<button className="ql-bold"></button>
		<button className="ql-italic"></button>
		<select className="ql-color">
			<option value="red"></option>
			<option value="green"></option>
			<option value="blue"></option>
			<option value="orange"></option>
			<option value="violet"></option>
			<option value="#d0d1d2"></option>
		</select>

		<div className="templates">

			{ templates ?

				<>

				<div>Use templates:</div>

				{Object.keys(templates).map((templates_key, templates_index) =>
					<button className="ql-insertText" value = {'#'+templates_key+'#'}  key={templates_index}>
						<span className="text_template">#{templates_key}#</span>
					</button>
				)}

				</>

				: null

			}
		</div>
	</div>
);

const CustomToolbarSimple = ({shortId, templates}) => (
	<div id={'t'+shortId}>

		<div className="templates simple">

			{ templates ?

				<>

				<div>Use templates:</div>

				{Object.keys(templates).map((templates_key, templates_index) =>
					<button className="ql-insertText" value = {'#'+templates_key+'#'}  key={templates_index}>
						<span className="text_template">#{templates_key}#</span>
					</button>
				)}

				</>

				: null

			}
		</div>
	</div>
);

export class Editor extends React.Component {

	modules = (shortId) => {
		return {
		toolbar: {
			container: "#t" + shortId,
			handlers: {
			insertText: insertText,

			},
		},
		}
	};

	formats = [
		'header',
		'font',
		'size',
		'bold',
		'italic',
		'underline',
		'strike',
		'blockquote',
		'list',
		'bullet',
		'indent',
		'link',
		'image',
		'color',
	];

	registerProps = {};
	constructor(props) {
		super(props);
		this.state = { editorHtml: this.props.value };
		this.handleChange = this.handleChange.bind(this);
		this.shortId = Math.random().toString(36).substr(2, 9);
		if (this.props.required)
			this.registerProps['required'] = "Required";
	}

	handleChange(html) {
		this.props.setValue(this.props.registerName, html);
		this.setState({ editorHtml: html});
	}


	//{...this.props.register(this.props.registerName, this.registerProps)}

	render() {
		return (
		<div className="text-editor">
		{this.props.type == 'simple' ?

		<CustomToolbarSimple
			shortId={this.shortId}
			templates={this.props.templates}
			/>

			:

			<CustomToolbar
			shortId={this.shortId}
			templates={this.props.templates}
			/>

		}


		<ReactQuill
			onChange={this.handleChange}
			value={this.state.editorHtml}
			modules={this.modules(this.shortId)}
			/>
		</div>
		);
	}
}
